import { AlertLevel, IconAlert } from '@shared/components/icon-alert/icon-alert'

type EnterOrScanAlertProps = {
  isError?: boolean
  message?: string
  title?: string
}

export function EnterOrScanAlert({
  isError = false,
  title = 'Enter or scan a reference number',
  message = `Scan the sample barcode or type 'X' on the keyboard.`,
}: EnterOrScanAlertProps) {
  const level = isError ? AlertLevel.WARNING : AlertLevel.INFO

  return <IconAlert title={title} message={message} level={level} />
}
